<template>
  <v-container class="pt-3 pb-0" v-if="items.length">
    <v-card
      v-for="(item, index) in items"
      v-if="item.render"
      :key="index"
      :class="{'box-clickable': item.linkUrl}"
      class="elevation-6 mb-3 sidebar-box">
      <v-card-media v-if="item.imageUrl" :src="item.imageUrl" :height="item.imageHeight || 200" @click="getUrl(item.linkUrl)" />
      <v-card-title v-if="item.heading || item.description" @click="getUrl(item.linkUrl)">
        <h5 v-if="item.heading" v-html="item.heading" class="subheading grey--text text--darken-1 pt-0 pb-3" />
        <div v-if="item.description" v-html="item.description" />
      </v-card-title>
    </v-card>
  </v-container>
</template>
<script>
  export default {
    name: 'SidebarBoxes',
    data () {
      return {
        items: this.$store.getters.sidebar.items.customBoxes || []
      }
    },
    methods: {
      getUrl (url, target) {
        if (url) {
          window.open(url, target || '_blank')
        }
      }
    }
  }
</script>
<style scoped>
.sidebar-box
{
  user-select: none;
}

.sidebar-box.box-clickable
{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/SidebarBoxes.vue